import NoteListDeleted from './NoteListDeleted';

export default NoteListDeleted;
